/**
 * API Configuration
 *
 * Centralizes API base URL configuration to ensure consistency
 * across all API calls and simplify environment-specific changes.
 *
 * @module apiConfig
 */

/**
 * Base URL for the backend API
 *
 * Uses relative URLs which work in both:
 * - Development: Vite proxy forwards /api to localhost:5001/api
 * - Production: Same server serves both frontend and backend
 */
export const API_BASE_URL = "/api";

/**
 * Get authentication headers for API requests.
 *
 * Cookies are automatically sent by the browser, so no Authorization header is needed.
 * This function only returns Content-Type header.
 *
 * @returns {Record<string, string>} Headers object with Content-Type
 */
export const getAuthHeaders = (): Record<string, string> => {
  return {
    "Content-Type": "application/json",
  };
};

